// src/components/mantenciones/MantencionBottomNav.jsx
import React from 'react';
import { theme, Badge } from 'antd';
import { MANTENCION_TABS as ITEMS } from './mantencionTabs';

const { useToken } = theme;

// Bottom-nav sticky de la pantalla de mantención. `problems` pinta el badge
// rojo sobre Checklist. Se renderiza dentro del área de contenido del
// LayoutMain (no full-screen): sticky al pie del scroll de la página.
function MantencionBottomNav({ tab, onChange, problems = 0 }) {
  const { token } = useToken();
  return (
    <div
      style={{
        position: 'sticky',
        bottom: 0,
        zIndex: 30,
        display: 'flex',
        background: token.colorBgContainer,
        borderTop: `1px solid ${token.colorBorderSecondary}`,
        boxShadow: token.boxShadowSecondary,
        // Reserva el rincón inferior derecho para el FloatButton global de
        // soporte (right:24 + 40px ancho) — evita que el FAB tape el item
        // "Bitácora". Ver e2e/_mantencion.inspect (solape detectado).
        padding: '8px 72px calc(8px + env(safe-area-inset-bottom)) 8px',
      }}
    >
      {ITEMS.map(({ k, label, Icon }) => {
        const on = tab === k;
        return (
          <button
            key={k}
            type="button"
            onClick={() => onChange(k)}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3,
              border: 0,
              background: 'transparent',
              color: on ? token.colorPrimary : token.colorTextTertiary,
              fontWeight: 600,
              fontSize: 11,
              cursor: 'pointer',
              padding: '4px 0',
            }}
          >
            <Badge count={k === 'checklist' ? problems : 0} size="small" offset={[2, -2]}>
              <Icon
                style={{ fontSize: 21, color: on ? token.colorPrimary : token.colorTextTertiary }}
              />
            </Badge>
            {label}
          </button>
        );
      })}
    </div>
  );
}

export default MantencionBottomNav;
